import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import axios from 'axios'
Vue.use(Router)
// 路由拦截
// router.beforeEach((to, from, next) => {
//   // ... 其他逻辑

//   // 检查版本更新
//   if (from.path !== '/') {
//     checkAppNewVersion()
//   }

// })
// // 检查服务端是否已经更新，如果更新刷新页面
// async function checkAppNewVersion() {
//   const url = `/version.json?t=${Date.now()}`
//   let res = null
//   try {
//     res = await axios.get(url)
//   } catch (err) {
//     console.error('checkAppNewVersion error: ', err)
//   }
//   if (!res) return
//   const version = res.data.version
//   const localVersion = Local.get(localKeys.APP_VERSION)
//   if (localVersion && localVersion !== version) {
//     Local.set(localKeys.APP_VERSION, version)
//     window.location.reload()
//   }
//   Local.set(localKeys.APP_VERSION, version)
// }

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('../view/Home.vue') //默认页
    },{
      path: '/CustomsClearanceConsole/ExportDeclaration',
      name: 'ExportDeclaration',
      component: () => import('../view/CustomsClearanceConsole/ExportDeclaration.vue')
    },{
      path: '/Home',
      name: 'Home',
      component: () => import('../view/Home.vue')
    },{
      path: '/other',
      name: 'other',
      component: () => import('../view/other.vue')
    },{
      path: '/DataCentre/DocumentWarehouse',
      name: 'DocumentWarehouse',
      component: () => import('../view/DataCentre/DocumentWarehouse.vue')
    },{
      path: '/DataCentre/BusinessStatistics',
      name: 'BusinessStatistics',
      component: () => import('../view/DataCentre/BusinessStatistics.vue')
    },
    {
      path: '/DataCentre/ActionAccounting',
      name: 'ActionAccounting',
      component: () => import('../view/ActionAccounting/index.vue')
    },
    {
      path: '/EnterpriseConsole/EssentialInformation',
      name: 'EssentialInformation',
      component: () => import('../view/EnterpriseConsole/EssentialInformation.vue')
    },{
      path: '/EnterpriseConsole/AccountManagement',
      name: 'AccountManagement',
      component: () => import('../view/EnterpriseConsole/AccountManagement.vue')
    },{
      path: '/PersonalCenter/EssentialInformation',
      name: 'EssentialInformation',
      component: () => import('../view/PersonalCenter/EssentialInformation.vue')
    },{
      path: '/FilePreview/FilePreview',
      name: 'FilePreview',
      component: () => import('../view/FilePreview/FilePreview.vue'),
      meta: {
        isMenu: false // 是否显示菜单
      }
    },{
      path: '/view/Home',
      name:'Home',
      component: resolve => require(['../view/Home.vue'], resolve)
    },{
      path: '/Login/Login',
      name:'Login',
      component: resolve => require(['../view/Login/Login.vue'], resolve)
    },{
      path: '/Demonstration/OrderSingleEntrustPage',
      name: 'OrderSingleEntrustPage',
      component: () => import('../view/Demonstration/OrderSingleEntrustPage.vue')
    },{
      path: '/Demonstration/OrderSingleEntrustTool',
      name: 'OrderSingleEntrustTool',
      component: () => import('../view/Demonstration/OrderSingleEntrustTool.vue')
    },{
      path: '/Error',
      name: 'Error',
      component: () => import('../view/Error/index.vue')
    },{
      path: '/MessagePanel',
      name: '消息面板',
      component: () => import('../view/MessagePanel/index.vue'),
      meta: {
        isMenu: false // 是否显示菜单
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js